import { Component, Input } from '@angular/core';

/**
 * Generated class for the ImageContainerComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'image-container',
  templateUrl: 'image-container.html',
  styleUrls:['./image-container.scss']
})
export class ImageContainerComponent {
  @Input('src')
  src;
  @Input('width')
  width;
  @Input('height')
  height;

  constructor() {
    if (!this.width) this.width = '100%';
    console.log(this.src, this.width, this.height);
  }
}
